const defaultState = () => ({
  data: [],
  skip: 0,
  limit: 0,
  total: 0
})

export default function(state = defaultState(), action) {
  switch (action.type) {
    case 'GET_ALL_DELEGATES_SUCCESS':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./routes/app/routes/delegate-list/reducer.js